/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy Counselor API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const GetCounselingPrescriptionImagesResponseTypename = "GetCounselingPrescriptionImagesResponse" as const;

/**
 *
 * @export
 * @interface GetCounselingPrescriptionImagesResponse
 */
export interface GetCounselingPrescriptionImagesResponse {
  /**
   *
   * @type {Array<string>}
   * @memberof GetCounselingPrescriptionImagesResponse
   */
  urls?: Array<string>;
  /**
   * Resource type name
   * @type {string}
   * @memberof GetCounselingPrescriptionImagesResponse
   */
  readonly __typename?: string;
}

export function GetCounselingPrescriptionImagesResponseFromJSON(json: any): GetCounselingPrescriptionImagesResponse {
  return GetCounselingPrescriptionImagesResponseFromJSONTyped(json, false);
}

export function GetCounselingPrescriptionImagesResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetCounselingPrescriptionImagesResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: GetCounselingPrescriptionImagesResponseTypename,

    urls: !exists(json, "urls") ? undefined : json["urls"],
  };
}

export function GetCounselingPrescriptionImagesResponseToJSON(
  object?: GetCounselingPrescriptionImagesResponse | null
): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    urls: value.urls,
  };
}
